import React from "react";
import TablePagination from "../../../TablePagination/TablePagination";

const DataTablePagination = ({
  query,
  setQuery,
  totalRecords,
  pageSizeOptions,
}) => {
  const totalPages = Math.ceil(totalRecords / query.pageSize) || 1;

  const changePage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setQuery((prev) => ({ ...prev, page }));
    }
  };

  return (
    <TablePagination
      currentPage={query.page}
      totalPages={totalPages}
      pageSize={query.pageSize}
      pageSizeOptions={pageSizeOptions}
      onPageChange={changePage}
      onPageSizeChange={(size) =>
        setQuery((prev) => ({ ...prev, pageSize: size, page: 1 }))
      }
    />
  );
};

export default DataTablePagination;
